import React from 'react';
import PropTypes from 'prop-types';

import OEButton from './oe-button';

export default class OERadioButton extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange()   {
        if(this.props.disabled || !this.props.onPressed) return;
        this.props.onPressed(this, this.props.userData);
    }

    render() {
        return (
            <div className={'radio-button ' + this.props.className + (this.props.disabled === true ? ' disabled' : '')}>
                <input type="radio" disabled={this.props.disabled} checked={this.props.checked} onChange={this.onChange}/>
            </div>
        );
    }
}

OERadioButton.defaultProps = {
    className: '',
    disabled: false,
    checked: false
};

OERadioButton.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onPressed: PropTypes.func
};

export class OECustomRadioButton extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onPressed = this.onPressed.bind(this);
    }

    onPressed()   {
        if(this.props.onPressed)    this.props.onPressed(this, this.props.userData);
    }

    render() {
        return (
            <OEButton
                className={'custom-radio-button ' + this.props.className}
                disabled={this.props.disabled}
                activated={this.props.checked}
                onPressed={this.onPressed}
            >
                <div className="crb-frame"/>
                <div className="crb-border"/>
                <div className="crb-handle"/>
            </OEButton>
        );
    }
}

OECustomRadioButton.defaultProps = {
    className: '',
    disabled: false,
    checked: false
};

OECustomRadioButton.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onPressed: PropTypes.func
};